﻿import * as networkService from "@arcgis/core/rest/networkService";
import {hasValue} from "./arcGisJsInterop";

export default class NetworkServiceWrapper {
    private dotNetRef: any;

    constructor(dotNetRef) {
        this.dotNetRef = dotNetRef;
    }

    async fetchServiceDescription(url: string, apiKey?: string | null, requestOptions?: any) {
        try {
            if (hasValue(apiKey)) {
                if (hasValue(requestOptions)) {
                    return await networkService.fetchServiceDescription(url, apiKey, requestOptions);
                }
                return await networkService.fetchServiceDescription(url, apiKey);
            }

            if (hasValue(requestOptions)) {
                return await networkService.fetchServiceDescription(url, requestOptions);
            }
            return await networkService.fetchServiceDescription(url);
        } catch (error) {
            console.debug(error);
            throw error;
        }
    }
}